import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

import { Unidade } from '../../../models/unidade';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/combineLatest';
import { ConfirmationService, SelectItem } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Util } from '../../shared/util';
import { FaseService } from '../fase.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { InscricaoService } from '../../../services/inscricao.service';
import { pairwise } from 'rxjs/operators';
import { EnumTipoEdital } from '../../../models/tipo-edital';
import { isNullOrUndefined } from 'util';
interface Categoria {
  Descricao: string,
  idCategoria: string,
  label: string
}

@Component({
  templateUrl: './cadastrar-editar-fase.component.html',
  styleUrls: ['./cadastrar-editar-fase.component.scss']
})
export class CadastrarEditarFaseComponent extends WebPage implements OnInit {
  categoria: SelectItem[];
  selectedCategoria: Categoria[] = [];

  display = false;
  editaUnidade = false;
  idFase;
  hasCandidatosOrEditaisCredenciamentoCadastrados = false;
  uploadUrl: string;
  unidades: Unidade[] = [] as Unidade[];
  arquivosToRemove = new FormArray([]);
  tipoJuridico = false;

  get nroVagasTotal() { return this.form.get('nroVagasTotal'); }
  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get unidadesSelecionadas() { return this.form.get('unidadesSelecionadas') as FormArray; }

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private faseService: FaseService,
    private unidadeService: UnidadeService,
    private arquivoService: ArquivoService,
    private inscricaoService: InscricaoService,
  ) {
    super(messageService);

    this.form = this.fb.group({
      idFase: [],
      nroFase: ['', Validators.required],
      nomeFase: ['', Validators.required],
      condicoes: [null, Validators.required],
      descricaoEditalVagas: ['', Validators.required],
      nroVagasTotal: [0],
      arquivos: new FormArray([]),
      unidadesSelecionadas: new FormArray([]),
      tipoEdital: ['', Validators.required],
      dataInicioJuridico: ['', [Validators.required, this.dataMenorQue("dataFimJuridico")]],
      dataFimJuridico: ['', [Validators.required, this.dataMaiorQue("dataInicioJuridico")]],
      dataInicioPessoal: ['', [Validators.required, this.dataMaiorQue("dataFimJuridico"), this.dataMenorQue("dataFimPessoal")]],
      dataFimPessoal: ['', [Validators.required, this.dataMaiorQue("dataInicioPessoal")]],
    });

    const camposData = ["dataInicioJuridico",
      "dataFimJuridico",
      "dataInicioPessoal",
      "dataFimPessoal"];
    
    camposData.forEach((v) => {
      this.form.get(v).valueChanges
      .pipe(pairwise())
      .subscribe(([prev,next]:[any,any]) => {
        if(prev === next) return;
        camposData.forEach((y) =>{
          if(y==v)return;
          this.form.get(y).updateValueAndValidity();
        })
      });
    })
    

    this.bloquearCamposData();

    this.uploadUrl = this.arquivoService.uploadUrl + 'editalFase';

    this.route.paramMap.subscribe(params => {
      if (params.has('idFase')) {
        this.idFase = params.get('idFase');
      }
    });
  }

  //validacao de campos de data

  private dataMenorQue(controlName: string): ValidatorFn {
    return (control: AbstractControl) : ValidationErrors | null =>{
    let invalid = false;
    if(this.form === null || this.form === undefined) return null;

    const controle = control.value;
    const controleComp = this.f[controlName].value;

    if(!controle || !controleComp){
      return null
    }
    //se a data do controle analisado for maior que a data de comparacao, retornar erro
    invalid = new Date(controle).valueOf() >= new Date(controleComp).valueOf();
    return invalid ? { invalidRangeMax: true } : null;
  }};

  private dataMaiorQue(controlName: string): ValidatorFn {
    return (control: AbstractControl) : ValidationErrors | null =>{
    let invalid = false;
    if(this.form === null || this.form === undefined) return null;

    const controle = control.value;
    const controleComp = this.f[controlName].value;

    if(!controle || !controleComp){
      return null
    }
    //se a data do controle analisado for menor que a data de comparacao, retornar erro
    invalid = new Date(controle).valueOf() <= new Date(controleComp).valueOf();
    return invalid ? { invalidRangeMin: true } : null;
  }};

  ngOnInit() {
    this.carregarUnidades();
    this.carregarCategorias();
    this.carregarFormChange();

    if (!Util.isNullOrEmptyOrUndefined(this.idFase)) {
      this.isLoading = true;
      this.faseService.getFull(this.idFase)
        .finally(() => this.isLoading = false)
        .subscribe(
          fase => {
            this.form.setValue({
              idFase: fase.idFase,
              nroFase: fase.nroFase,
              nomeFase: fase.nomeFase,
              condicoes: fase.condicoes,
              descricaoEditalVagas: fase.descricaoEditalVagas,
              nroVagasTotal: 0,
              arquivos: [],
              unidadesSelecionadas: [],
              tipoEdital: isNullOrUndefined(fase.tipoEdital) ? 'pf' : (fase.tipoEdital.nome === "Pessoa Jurídica" ? 'pj' : 'pf' ),
              dataInicioJuridico: isNullOrUndefined(fase.dataInicioJuridico)? '': this.getOnlyDate(fase.dataInicioJuridico),
              dataFimJuridico: isNullOrUndefined(fase.dataFimJuridico) ? '': this.getOnlyDate(fase.dataFimJuridico),
              dataInicioPessoal: isNullOrUndefined(fase.dataInicioPessoal)  ? '': this.getOnlyDate(fase.dataInicioPessoal),
              dataFimPessoal: isNullOrUndefined(fase.dataFimPessoal)  ? '': this.getOnlyDate(fase.dataFimPessoal)
            });
            fase.arquivosMeio.forEach(arquivoMeio =>
              this.adicionaArquivo(arquivoMeio.idArquivo, arquivoMeio.arquivo.nome, true)
            );

            fase.faseUnidades.forEach(faseUnidade => {
              const unidade = faseUnidade.unidade;
              const categorias = faseUnidade.faseUnidadeCategoria.map((v) => v.idCategoria);
              this.adicionaOuEditaUnidade(
                faseUnidade.idUnidade,
                unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf,
                faseUnidade.inicioInscricoes,
                faseUnidade.encerramentoInscricoes,
                faseUnidade.nroVagas,
                faseUnidade.idFaseUnidade,
                categorias ? categorias : []
              );
            });
            this.hasCandidatosOrEditaisCredenciamentoCadastrados =
              (fase.candidatos.length !== 0 || fase.editaisCredenciamento.length !== 0);
          },
          error => this.gerenciaErro(error)
        );
    }
  }

  getOnlyDate(dateString:string){
    const splitString = dateString.split("T");
    if(splitString !== null && splitString.length > 1){
      return splitString[0];
    }
    return "";
  }

  carregarFormChange(){
    this.form.controls.tipoEdital.valueChanges.subscribe(change => {
      const pj = change == "pj";
      this.tipoJuridico = pj;

      if(pj) {
        this.limparDadosUnidades();
        this.desbloquearCamposData();
      }
      else this.bloquearCamposData();
    })
  }

  bloquearCamposData(){
    const camposData = ["dataInicioJuridico",
      "dataFimJuridico",
      "dataInicioPessoal",
      "dataFimPessoal"]
    camposData.forEach((v)=>{
      this.f[v].disable()
      this.f[v].reset('')
    })
    this.f["unidadesSelecionadas"].enable()
  }

  desbloquearCamposData(){
    const camposData = ["dataInicioJuridico",
      "dataFimJuridico",
      "dataInicioPessoal",
      "dataFimPessoal"]
    camposData.forEach((v)=>{
      this.f[v].enable()
    })
  }

  limparDadosUnidades(){
    this.f["unidadesSelecionadas"].disable();
    const clearFormArray = (formArray: FormArray) => {
      while (formArray.length !== 0) {
        formArray.removeAt(0)
      }
    }
    clearFormArray(this.f["unidadesSelecionadas"] as FormArray);
    this.recalcularNroVagasTotal();
  }

  carregarCategorias() {
    this.isLoading = true;
    this.inscricaoService.getListaCategoria()
    .finally(() => this.isLoading = false)
    .subscribe(
      categoria => {

        // Filtrar apenas as categorias "Categoria D" e "Categoria E"
        const categoriasSelecionadas = categoria.filter(categoria => categoria.descricao === "Categoria D" || categoria.descricao === "Categoria E");


        // Mapear os objetos Categoria para o formato {label: '', value: {}}
        this.categoria = categoriasSelecionadas.map(categoria => {
          return {
            label: categoria.descricao,
            value: categoria.idCategoria
          };
        });
      },
      error => this.gerenciaErro(error)
    );
  }

  getCategoriasLetters(categorias: string[]){
    if(categorias !== null && this.categoria !== undefined) {
      let categoriasAdicionadas = this.categoria.filter((v) => categorias.includes(v.value));

      let categoriaComSigla = categoriasAdicionadas.map((v) => {
        return v.label.slice(-1)[0];
      });

      return categoriaComSigla.length > 0 ? categoriaComSigla.map(String).join(' - ') : "-";
    }
    return "-"
  }

  carregarUnidades() {
    this.isLoading = true;
    this.unidadeService.getUnidades()
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => this.unidades = unidades,
        error => this.gerenciaErro(error)
      );
  }

  // ------
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }
  // Arquivo
  // ------

  // ------
  // Unidade
  mostrarDialog() {
    this.display = true;
  }

  enviaUnidade(unidadeSelecionada: HTMLSelectElement, nroVagas: HTMLInputElement, inicioInscricoes, encerramentoInscricoes) {
    if (!this.validaUnidade(unidadeSelecionada.value, nroVagas.value, inicioInscricoes.value, encerramentoInscricoes.value, this.selectedCategoria)) {
      return;
    }

    this.adicionaOuEditaUnidade(
      unidadeSelecionada.value,
      unidadeSelecionada[unidadeSelecionada.selectedIndex].innerHTML,
      inicioInscricoes.value,
      encerramentoInscricoes.value,
      +nroVagas.value,
      null,
      this.selectedCategoria
    );

    this.limparDadosModal(unidadeSelecionada, inicioInscricoes, encerramentoInscricoes, nroVagas);
  }

  validaUnidade(unidadeSelecionada, nroVagas, inicioInscricoes, encerramentoInscricoes, categorias) {
    if (+nroVagas <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas inválido' });
      return false;
    }

    if (unidadeSelecionada === '0') {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione alguma unidade' });
      return false;
    }

    if (inicioInscricoes === undefined || encerramentoInscricoes === undefined) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione ambas as datas' });
      return false;
    }

    if(!(categorias.length > 0)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione alguma categoria' });
      return false;
    }

    if (encerramentoInscricoes < inicioInscricoes) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A data do encerramento das inscrições não pode ser menor que a data de início das inscrições.'
      });
      return false;
    }

    return true;
  }

  limparDadosModal(unidadeSelecionada, inicioInscricoes, encerramentoInscricoes, nroVagas) {
    this.display = false;
    this.selectedCategoria = [];

    unidadeSelecionada.selectedIndex = 0;
    unidadeSelecionada.disabled = false;
    inicioInscricoes.inputFieldValue = '';
    encerramentoInscricoes.inputFieldValue = '';
    nroVagas.value = '0';
  }

  adicionaOuEditaUnidade(idUnidade, nomeUnidade, inicioInscricoes, encerramentoInscricoes, nroVagas, idFaseUnidade = null, categorias = []) {
    const unidadeSelecionada = this.unidadesSelecionadas.controls.find(us => us.value.idUnidade === idUnidade);
    //está com erro por aqui

    if (unidadeSelecionada === null || unidadeSelecionada === undefined) {
      const unidadeFormGroup = this.fb.group({
        idUnidade: idUnidade,
        nomeUnidade: nomeUnidade,
        inicioInscricoes: inicioInscricoes,
        encerramentoInscricoes: encerramentoInscricoes,
        nroVagas: +nroVagas,
        idFaseUnidade: idFaseUnidade,
        categorias: [categorias]
      });
      this.unidadesSelecionadas.push(unidadeFormGroup);
    } else {
      unidadeSelecionada.value.inicioInscricoes = inicioInscricoes;
      unidadeSelecionada.value.encerramentoInscricoes = encerramentoInscricoes;
      unidadeSelecionada.value.nroVagas = nroVagas;
      unidadeSelecionada.value.categorias = categorias;
    }

    this.recalcularNroVagasTotal();

    const unidade = this.unidades.find(u => u.idUnidade === idUnidade);
    const index = this.unidades.indexOf(unidade);
    this.unidades.splice(index, 1);
  }

  abreEdicaoUnidadeSelecionada(
    unidade,
    unidadeSelecionada: HTMLSelectElement,
    inicioInscricoes,
    encerramentoInscricoes,
    nroVagas: HTMLInputElement
  ) {
    this.display = true;

    const unidadeOption = new Option(unidade.value.nomeUnidade, unidade.value.idUnidade);
    unidadeSelecionada.add(unidadeOption);

    unidadeSelecionada.value = unidadeOption.value;
    unidadeSelecionada.disabled = true;

    this.selectedCategoria = unidade.value.categorias != null  ? unidade.value.categorias: [];
    const inidata = new Date(unidade.value.inicioInscricoes);
    inicioInscricoes.value = inidata;
    inicioInscricoes.inputFieldValue = inidata.getDate() + '/' + (inidata.getMonth() + 1) + '/' + inidata.getFullYear();

    const encdata = new Date(unidade.value.encerramentoInscricoes);
    encerramentoInscricoes.value = encdata;
    encerramentoInscricoes.inputFieldValue = encdata.getDate() + '/' + (encdata.getMonth() + 1) + '/' + encdata.getFullYear();

    nroVagas.value = unidade.value.nroVagas;
  }

  removeUnidadeSelecionada(unidade) {
    const index = this.unidadesSelecionadas.controls.indexOf(unidade);
    this.unidadesSelecionadas.removeAt(index);

    this.recalcularNroVagasTotal();
  }
  // Unidade
  // ------

  recalcularNroVagasTotal() {
    let soma = 0;
    this.unidadesSelecionadas.controls.forEach(us =>
      soma = soma + us.value.nroVagas
    );
    this.nroVagasTotal.setValue(soma);
  }

  criarEditarFase() {
    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja confirmar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);

        this.isLoading = true;
        this.faseService.cadastrarEditarFase(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              localStorage.setItem('mensagem', 'Registro salvo com sucesso!');
              this.router.navigate(['/gerenciar-editais']);
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  // TODO isto pode ser um exit guard
  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-editais']);
      }
    });
  }

  get f(){
    return this.form.controls;
  }

  erroRequired(campo:string){
    return this.f[campo].errors && this.f[campo].errors.required !== undefined && this.f[campo].touched;
  }

  erroMax(campo:string){
    return this.f[campo].errors && this.f[campo].errors.invalidRangeMax !== undefined && (this.f[campo].touched || this.f[campo].value);
  }

  erroMin(campo:string){
    return this.f[campo].errors &&  this.f[campo].errors.invalidRangeMin !== undefined && (this.f[campo].touched || this.f[campo].value);
  }

  validaForm(): boolean {
    if (this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
      return false;
    }

    if (this.unidadesSelecionadas.length <= 0 && !this.tipoJuridico) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'É necessário adicionar ao menos uma Unidade Operacional!'
      });
      return false;
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fase/cadastrar-editar/cadastrar-editar-fase.component.ts